export const DEFAULT_IDM_USER_LOCATION_PREFERENCE = {
  externalId: '',
  assetExternalId: '',
  threeDConfiguration: {
    fullWeightModels: [],
  },
};
